
__webpack_public_path__ = window.__webpack_public_path__;

import 'core-js';
import 'regenerator-runtime'; // for async/await

import 'scripts/helpers/external-links.js';

import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import VueScript2 from 'scripts/lib/script2.js';
import VueLazyLoad from 'vue-lazyload';
import VueMq from 'vue-mq';
import VueScrollTo from 'vue-scrollto';
import { mapState } from 'vuex';

import components from './components';
import store from './store';
import { ucfirst, upcase, unhandleize } from './filters/string.js';
import { money, moneyWithoutDecimals } from './filters/money.js';

import imageConfig from 'scripts/config/images.js';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import Vuemoment from 'vue-moment';
import IOLazyLoad from 'scripts/helpers/vanilla-io-lazyload.js';
import RechargeDashboard from 'scripts/helpers/subscriptions.js';


document.addEventListener('DOMContentLoaded', IOLazyLoad.setupObservers);
document.addEventListener('DOMContentLoaded', RechargeDashboard.setup);

const cssVars = require('../styles/variables.scss');
const appProxy = window.bva && window.bva.template === null;
Vue.config.productionTip = false;
Vue.use(Vue2TouchEvents);
Vue.use(VueScript2);

Vue.use(VueLazyLoad, {
  preload: 1.3,
  loading: imageConfig.loading,
  attempt: 1,
});

Vue.use(VueMq, {
  breakpoints: {
    mobile: parseInt(cssVars.breakTablet, 10),
    tablet: parseInt(cssVars.breakDesktop, 10),
    desktop: parseInt(cssVars.breakHd, 10),
    hd: Infinity,
  },
});

Vue.use(VueScrollTo, {
  container: "body",
});
//let scrollUp = VueScrollTo.scrollTo(element, duration, options);

Vue.filter('ucfirst', ucfirst);
Vue.filter('upcase', upcase);
Vue.filter('unhandleize', unhandleize);
Vue.filter('money', money);
Vue.filter('moneyWithoutDecimals', moneyWithoutDecimals);
const dataURL = 'https://joshua-tree-coffee-company.myshopify.com/products/subscription-test.json';
const dataURL2 = 'https://joshua-tree-coffee-company.myshopify.com/products/subscription-pre-paid.json';
//const collectionURL = 'https://joshua-tree-coffee-company.myshopify.com/collections/subscriptions/products.json';
const collectionURL = 'https://joshua-tree-coffee-company.myshopify.com/collections/subscriptions-auto-renew/products.json';

let dateFirstShipment = new Date();
//dateFirstShipment.setHours( dateFirstShipment.getHours() + 24); 
//let dateFirstShipmentFormatted = moment(dateFirstShipment).format('MMMM Do YYYY')


try {
  new Vue({
  delimiters: ['${', '}'],
  store,
  components,
  comments: true,
  data:{
    currentStep:2,
    completedStep:1,
    direction: 'nextStep',
    summary: false,
    gift: false,
    active: 'wait',
    coffeeType: '',
    coffeeTypeImg: '',
    coffeeParent: '',
    coffeeOptions: [],
    coffeeOptionsProductHandle: [],
    beanGrind: '',
    beanGrindImg: '',
    size: '',
    sizeImg: '',
    sizeNum: '',
    shippingPrice: '',
    quantity: '',
    frequency: '',
    frequencyImg: '',
    freq_gift_title: '',
    frequencyNum: '',
    duration: '',
    durationImg: '',
    durationNum: '',
    variantId: '',
    variantTitle:'',
    compareTitle:'',
    ship_date:'',
    finalID:'',
    giftName:'',
    giftEmail:'',
    cartNote:'',
    giftWrap: false,
    cartNoteSelected: false,
    giftWrapVariantId: '',
    cartNoteVariantId: '',
    show: true,
    productHandle: '',
    product: [], // initialize empty array
    variant: [], // initialize empty array
    variantData: [], // initialize empty array
    collection: [], // initialize empty array
    VariantSubscriptionMap: {},
    subscription_id: '',
    hasSellingPlan: false,
    sellingPlanId: '',
    date: '',
    dateFormat: '',
    disabledDates: {to: dateFirstShipment},
    moment: moment,
    contact: {
      name: '',
      email: '',
    },
    grindOrder: 'alpha',
    popProductHandle: 'the-first-roast',
    popProduct: [],
    showPopReviews: false,
    currentRoast: '',
    roastsOpen: false,
    roastLevel: '',
    metafieldDefaultSubscription: ''
  },

  computed: {
    ...mapState({
      checkout: state => state.cart.checkout,
    }),
    featuredProductSlidesToShow () {
      if (this.$mq === 'mobile') return 1.8;
      if (this.$mq === 'tablet') return 3;
      return 4;
    },
    numShipments: function() {
      //console.log(this.durationNum, this.frequencyNum)
      var num = this.durationNum / this.frequencyNum;
      return Math.floor(num);
    },
    formattedPrice: function() {
      if (!this.variant || !this.variant.price) return '0.00';
      return typeof this.variant.price === 'number' ? (this.variant.price / 100).toFixed(2) : this.variant.price;
    },
    formattedComparePrice: function() {
      if (!this.variant || !this.variant.compare_at_price) return null;
      return typeof this.variant.compare_at_price === 'number' ? (this.variant.compare_at_price / 100).toFixed(2) : this.variant.compare_at_price;
    },
    pricePerCoffee: function() {
      if (!this.variant || !this.variant.price) {
        return '0.00';
      }
      
      // Check if price is in cents (number) or dollars (string)
      var price = typeof this.variant.price === 'number' ? this.variant.price / 100 : parseFloat(this.variant.price);
      
      var shipping = this.numShipments * Number.parseFloat(this.shippingPrice);
      var remainingCost = price - shipping;
      var eachCoffee = (remainingCost / this.numShipments).toFixed(2);
      return eachCoffee;
    },
    productUrl: function() {
      return "https://jtcoffee.com/products/" + this.popProductHandle;
    }
  },

  created () {
    this.$store.dispatch('params/init');
    this.$store.dispatch('cart/init');
    this.$store.dispatch('products/init');

    if (appProxy) {
      document.body.appendChild(document.getElementById('MainContent'));
    }
    var currentPage = window.location.pathname.split("/").pop();
    //console.log(currentPage)
    var self = this // create a closure to access component in the callback below
    if (currentPage === 'send-a-gift') {
      this.gift = true;
    }
    /* if (currentPage !== 'send-a-gift') {
      $.getJSON(dataURL, function (data) {
        self.product = data;
        console.log('product', data)
      });

    }else {
      this.gift = true;
      $.getJSON(dataURL2, function (data) {
        self.product = data;
        console.log('product', data)
      });
      $.getJSON(collectionURL, function (data) {
        self.collection = data;
        console.log('collection', data)
      });
    } */
  },
  mounted() {
    // on mount, start listening for load events
    // on a section load, re-mount section to reflect admin changes
    this.getPopProduct();

    document.addEventListener('shopify:section:load', (event) => {
      const sectionContainer = document.getElementById(event.target.id);
      const NewComponent = Vue.extend({
        components,
        store,
        Datepicker,
        moment,
        template: event.target.innerHTML,
      });
      const component = new NewComponent().$mount();

      sectionContainer.innerHTML = '';
      sectionContainer.appendChild(component.$el);
    });

    if (appProxy){
      document.getElementById('MainContentWrapper').appendChild(document.getElementById('MainContent'));
    }

    // Auto-select third roast on explore-roasts page
    setTimeout(() => {
      var slides = document.querySelectorAll('.roast-slide');
      if (slides.length >= 3) {
        slides[2].dispatchEvent(new Event('mouseover', { bubbles: true }));
      }
    }, 500);

  },

  watch: {
    date: function (val) {
      var selectedDate = val.setHours(0,0,0,0);
      var compareDate = dateFirstShipment.setHours(0,0,0,0);
      var theInput = document.querySelector('#gift-wrap');

      if (selectedDate > compareDate) {
        this.giftWrap = false;
        if (theInput) {
          theInput.setAttribute('disabled', '');
          theInput.closest('.input--checkbox').classList.add('disabled');
        }
        
      } else {

        if (theInput) {
          theInput.removeAttribute('disabled', '');
          theInput.closest('.input--checkbox').classList.remove('disabled');
        }

      }
    },
    grindOrder: function() {
      let grindItems = Array.from(document.querySelectorAll('.grind-item'));
      if (this.grindOrder === 'low') {
        grindItems.forEach((el) => {
          el.parentElement.style.order = el.dataset.grind_size;
        })
      }
      if (this.grindOrder === 'popular') {
        grindItems.forEach((el) => {
          el.parentElement.style.order = el.dataset.grind_pop;
        })
      }
      if (this.grindOrder === 'high') {
        grindItems.forEach((el) => {
          el.parentElement.style.order = parseInt(el.dataset.grind_size) * -1;
        })
      }
      if (this.grindOrder === 'alpha') {
        grindItems.forEach((el) => {
          el.parentElement.style.order = '';
        })
      }
    },
  },
  methods: {
    changeRoast(handle) {
      this.currentRoast = handle;
      let roastSlides = document.querySelectorAll('.roast-slide');
      let extraDetailsWrap = document.querySelector('.roast-extra-details');
      extraDetailsWrap.classList.add('open');
      roastSlides.forEach(function(el) {
        el.classList.remove('roast_slide_active')
      });
      let slideStr = '.roast-slide.' + handle;
      let roastSlide = document.querySelector(slideStr);
      roastSlide.classList.add('roast_slide_active');

      // if small screens, don't move the details box!!!
      if (window.innerWidth < 1023) return;

      let currentSlide = event.target.closest('.roast-slide');
      let slideBox = currentSlide.getBoundingClientRect();
      let slideX = parseInt(slideBox['left'], 10);
      let slideW = parseInt(slideBox['width'], 10);

      let detailsDiv = document.querySelector('.roast-extra-details');
      let detailsBox = detailsDiv.getBoundingClientRect();
      let detailsX = parseInt(detailsBox['left'], 10);
      let detailsW = parseInt(detailsBox['width'], 10);

      let widthDiff = detailsW - slideW;
      let xTarget = slideX - (widthDiff / 2);
      let targetDiff;

      // get original position from css width
      let firstPos = (window.innerWidth / 2) - 221;

      if (firstPos > xTarget) {
        targetDiff = firstPos - xTarget;
        if (targetDiff > firstPos) {
          targetDiff = firstPos - 8;
        }
        detailsDiv.style.transform = 'translateX(-' + targetDiff + 'px)';
      } else if (firstPos < xTarget) {
        targetDiff = xTarget - firstPos;
        if (targetDiff > firstPos) {
          targetDiff = firstPos - 8;
        }
        detailsDiv.style.transform = 'translateX(' + targetDiff + 'px)';
      }
    },
    getPopProduct() {
      console.log('getPopProduct called')
      var create_URL = "https://joshua-tree-coffee-company.myshopify.com/products/"+ this.popProductHandle + ".json";
      var vm = this;
      $.getJSON(create_URL)
        
        //console.log('vm.product:::', vm.product);
        .done(function( data ) {
          vm.product = data;
          console.log( "JSON Done: " );
        })
        .fail(function( jqxhr, textStatus, error ) {
          var err = textStatus + ", " + error;
          console.log( "Request Failed: " + err );
      });
        
    },
    productModal(handle, roast, defaultSub) {
      console.log('ProductModal called: ', handle);
      if (handle) {
        this.popProductHandle = handle;
        this.roastLevel = roast;
        this.metafieldDefaultSubscription = defaultSub;
        this.getPopProduct();
        this.$store.dispatch('products/init');
        this.$store.dispatch('products/addProduct', handle);
        var pm = document.querySelector('.product-modal');
        console.log('Adding is-open class, pm element:', pm);
        pm.classList.add('is-open');
        console.log('After adding class, classList:', pm.classList.toString());
        if (this.metafieldDefaultSubscription === 'true') {
          var subRadioBtn = document.querySelector('.option-select__label-wrapper label:last-of-type input');
          if (subRadioBtn) {
            subRadioBtn.click();
          }
        } else {
          var subRadioBtn = document.querySelector('.option-select__label-wrapper label:first-of-type input');
          if (subRadioBtn) {
            subRadioBtn.click();
          }
        }
      }
    },
    closeProductModal() {
      var pm = document.querySelector('.product-modal');
      pm.classList.remove('is-open');
      this.showPopReviews = false;
    },
    togglePopReviews() {
      this.showPopReviews = !this.showPopReviews;
    },
    getProduct (){
      var create_handle = this.duration + "-" + this.freq_gift_title + "-" + this.coffeeType; // build some sort of consitent string with selected variables
      //console.log('create_handle ', create_handle);
      create_handle = create_handle.replace(/\s+/g, '-').toLowerCase();
      this.productHandle = create_handle;
      //console.log('create_handle ', create_handle);

      var create_URL = "https://joshua-tree-coffee-company.myshopify.com/products/"+ create_handle + ".js";

      this.compareTitle = this.size + ' / ' + this.beanGrind;
      var compareIt = this.compareTitle;

      var vm = this;
      $.getJSON(create_URL, function (data) {
        vm.product = data;

        if (vm.product && vm.product.selling_plan_groups && vm.product.selling_plan_groups.length > 0) {
          vm.hasSellingPlan = true;
          vm.sellingPlanId = vm.product.selling_plan_groups[0].selling_plans[0].id;
        } else {
          vm.hasSellingPlan = false;
        }

        for (let i = 0; i < vm.product.variants.length; i++){
          var variant_test = vm.product.variants[i].title
          if (variant_test == compareIt) {
            vm.variant = vm.product.variants[i];
            var handle = vm.productHandle;
            var item = vm.product.variants[i].id;
            vm.finalID = vm.product.variants[i].id;

            //console.log('vm.variant: ', vm.variant)
            //console.log('use this ID', vm.product.variants[i].id)
            //console.log('use this price', vm.product.variants[i].price)
            //vm.finalID = vm.product.variants[i].id
            break;

          }
        }
      });


      /* for(var i = 0; i < this.collection.products.length; i++) { //loop through the collection
        var obj = this.collection.products[i];
        console.log('obj: ', obj)
        if (obj.handle == create_handle){ // if new created tag matches on from the products in the collection, set that product ID to be current.
          //somehow get the proper products JSON. build new JSON url and do a GETJSON? and set this.product to it?
          
        }
      } */
    },

    goToStep(step) {
      //VueScrollTo.scrollTo('#subscription-app', 500, { easing: VueScrollTo.easing['ease'] });
      this.$scrollTo('#subscription-app', 200, { easing: 'linear' })
      if(step>this.currentStep){
        this.direction='nextStep'
      }
      else{
        this.direction='previousStep'
      }
      this.currentStep = step;
      if (this.currentStep == 7){
        this.compareTitle = this.size + ' / ' + this.beanGrind;
          //console.log('this product: ', this.product)
          for (let i = 0; i < this.product.variants.length; i++){
            var variant_test = this.product.variants[i].title;
            if (variant_test == this.compareTitle) {
              this.variant = this.product.variants[i];
              var handle = this.productHandle;
              //console.log('testing handle: ', handle);
              var item = this.product.variants[i].id;
              
              // Check for selling plans when moving to step 7
              if (this.product && this.product.selling_plan_groups && this.product.selling_plan_groups.length > 0) {
                this.hasSellingPlan = true;
                var sellingPlans = this.product.selling_plan_groups[0].selling_plans;

                // Match selling plan based on frequency
                let cleanFrequency = typeof this.frequency === 'string' ? parseInt(this.frequency.replace(/\D/g,'')) : this.frequency;
                let frequencyWeeks = Math.round(cleanFrequency / 7);
                let frequencyMonths = Math.round(cleanFrequency / 30);
                
                // Try to find a matching plan based on the frequency
                let matchedPlan = sellingPlans.find(plan => {
                  const planNameLower = plan.name.toLowerCase();
                  
                  // Check for week-based matches
                  if (cleanFrequency == 7 && (planNameLower.includes('1 week') || planNameLower.includes('7 day'))) {
                    return true;
                  }
                  if (cleanFrequency == 14 && (planNameLower.includes('2 week') || planNameLower.includes('14 day'))) {
                    return true;
                  }
                  if (cleanFrequency == 21 && (planNameLower.includes('3 week') || planNameLower.includes('21 day'))) {
                    return true;
                  }
                  if (cleanFrequency == 28 && (planNameLower.includes('4 week') || planNameLower.includes('28 day'))) {
                    return true;
                  }
                  if (cleanFrequency == 30 && (planNameLower.includes('1 month') || planNameLower.includes('30 day'))) {
                    return true;
                  }
                  if (cleanFrequency == 60 && (planNameLower.includes('2 month') || planNameLower.includes('60 day'))) {
                    return true;
                  }
                  
                  // Generic number matching
                  if (planNameLower.includes(cleanFrequency.toString())) {
                    return true;
                  }
                  
                  return false;
                });
                
                if (matchedPlan) {
                  this.sellingPlanId = matchedPlan.id;
                } else {
                  // Fallback to first plan if no match
                  this.sellingPlanId = sellingPlans[0].id;
                }
              } else {
                this.hasSellingPlan = false;
                this.sellingPlanId = null;
              }
              
              // Always use the variant ID - selling plans handle subscription pricing
              this.finalID = this.product.variants[i].id
              
              //console.log('use this ID else', this.finalID)
              //console.log('use this price else', this.variant.price);
            }
          }
      }else {
        $('.sidebar').show();
      }
    },

    /* this could be used in a true/false condition to display or not display offered sizes
    checkVariantExists(sizeTitle) {
      
      var coffeeVariant = this.coffeeType + ' / ' + sizeTitle;
      var item = this.variantData.find( item => {
        return item.title === coffeeVariant
      });
      if (item === undefined) {
        return false
      } else {
        return true
      }
    }, */
    getVariantPrice(sizeTitle) {
      this.sizeTitle = sizeTitle;
      var coffeeVariant = this.coffeeType + ' / ' + sizeTitle;
      let item = this.variantData.find( item => {
          return item.title === coffeeVariant
      });
      if (item === undefined) {
        return ' '
      } else {
        return '$' + item.price
      }
    },
    appear: function(el) {
    },
    chooseGift(value) {
      this.gift = value;
    },
    selectCoffeeType(type, img) {
      this.coffeeType = type;
      this.coffeeTypeImg = img;
      this.setProductHandle(type);
      if (this.completedStep < 2) {
        this.completedStep = 2;
        //console.log('this.completedStep: ', this.completedStep)
      }
    },
    selectCoffeeTypeGift(type, img) {
      this.coffeeType = type;
      this.coffeeTypeImg = img;
      if (this.completedStep < 2) {
        this.completedStep = 2;
        //console.log('this.completedStep: ', this.completedStep)
      }
    },
    selectBeanGrind(bean, beanimg) {
      this.beanGrind = bean;
      this.beanGrindImg = beanimg;
      if (this.completedStep < 3) {
        this.completedStep = 3;
        //console.log('this.completedStep: ', this.completedStep)
      }
    },
    selectSize(sizeValue, sizeimg, shippingPrice) {
      this.size = sizeValue;
      this.sizeImg = sizeimg;
      this.shippingPrice = shippingPrice;

      if (sizeValue.toLowerCase().indexOf('one') !== -1) {
        this.sizeNum = 1;
      }
      if (sizeValue.toLowerCase().indexOf('two') !== -1) {
        this.sizeNum = 2;
      }
      if (sizeValue.toLowerCase().indexOf('four') !== -1) {
        this.sizeNum = 3;
      }

      if (this.completedStep < 4) {
        this.completedStep = 4;
        //console.log('this.completedStep: ', this.completedStep)
      }
    },
    frequencyTime(freq, freqimg) {
      this.frequency = freq;
      this.frequencyImg = freqimg;
      if (this.completedStep < 5) {
        this.completedStep = 5;
        //console.log('this.completedStep: ', this.completedStep)
      }
      
      // If we're on step 7, we need to re-select the variant since frequency changed
      if (this.currentStep == 7 && this.product && this.product.variants) {
        this.compareTitle = this.size + ' / ' + this.beanGrind;
        for (let i = 0; i < this.product.variants.length; i++){
          var variant_test = this.product.variants[i].title;
          if (variant_test == this.compareTitle) {
            this.variant = this.product.variants[i];
            break;
          }
        }
      }
    },
    frequencyTimeGift(freq, freqimg, freq_gift_title) {
      this.frequency = freq;
      this.frequencyImg = freqimg;
      this.freq_gift_title = freq_gift_title;

      if (freq.indexOf('7') !== -1) {
        this.frequencyNum = 7;
      }
      if (freq.indexOf('14') !== -1) {
        this.frequencyNum = 14;
      }
      if (freq.indexOf('30') !== -1) {
        this.frequencyNum = 30;
      }

      if (this.completedStep < 5) {
        this.completedStep = 5;
        //console.log('this.completedStep: ', this.completedStep)
      }
      
      // If we're on step 7, we need to re-select the variant since frequency changed (for gift flow)
      if (this.currentStep == 7 && this.product && this.product.variants) {
        this.compareTitle = this.size + ' / ' + this.beanGrind;
        for (let i = 0; i < this.product.variants.length; i++){
          var variant_test = this.product.variants[i].title;
          if (variant_test == this.compareTitle) {
            this.variant = this.product.variants[i];
            break;
          }
        }
      }
    },
    durationTime(dur, durimg) {
      this.duration = dur;
      this.summary = true;
      this.durationImg = durimg;
      
      if (dur.toLowerCase().indexOf('3') !== -1) {
        this.durationNum = 90;
      }
      if (dur.toLowerCase().indexOf('4') !== -1) {
        this.durationNum = 120;
      }
      if (dur.toLowerCase().indexOf('6') !== -1) {
        this.durationNum = 180;
      }
      if (dur.toLowerCase().indexOf('12') !== -1) {
        this.durationNum = 360;
      }

      if (this.completedStep < 6) {
        this.completedStep = 6;
        //console.log('this.completedStep: ', this.completedStep)
      }
      
      // For gift subscriptions, fetch the product when duration is selected
      if (this.gift && this.freq_gift_title && this.coffeeType) {
        this.getProduct();
      }
    },
    openPicker() {
      this.$refs.programaticOpen.showCalendar();
      const theInput = document.querySelector('#datedate');
      theInput.click();
    },
    customFormatter(date) {
      this.dateFormat = moment(date).format('MMMM Do YYYY');
      this.date = date;
    },
    getVariantData() {
      var create_URL = "https://joshua-tree-coffee-company.myshopify.com/products/"+ this.productHandle + ".js";
      fetch(create_URL).then(response => {
        // The API call was successful!
        if (response.ok) {
            return response.json();
        } else {
            return Promise.reject(response);
        }
    }).then( data => {
        this.product = data;
        this.variantData = data.variants;
    }).catch(function (err) {
    });

    },// this.productHandle is reset for gifts in getProduct()
    setProductHandle(productHandle) {
      var productHandleCleaned = productHandle.replace(/\s/g, '-');
      productHandleCleaned = productHandleCleaned.toLowerCase();
      // Add -coffee-subscription suffix to match the subscription products
      productHandleCleaned = productHandleCleaned + '-coffee-subscription';
      this.productHandle = productHandleCleaned;
      this.getVariantData();
    },
    setVariantSubscriptionMap(handle, data) {
      var tmp = "{" + data + "}";
      var tmp2 =JSON.parse(tmp);
      //console.log('handle: ', handle, ' type of data now: ', typeof tmp2, tmp2)
      this.VariantSubscriptionMap[handle] = tmp2;
    },
    setCoffeeOptions(name, data) {
      var tmp1a = "{" + data + "}";
      var tmp1b =JSON.parse(tmp1a);
      this.coffeeOptionsProductHandle = name;
      this.coffeeOptions[name] = tmp1b;
    },
    setCoffeeParent(parent) {
      this.coffeeParent = parent;
    },
    checkGrind(current) {
      //console.log('current', current)
      //console.log('this.coffeeOptions[this.coffeeParent]: ', this.coffeeOptions[this.coffeeParent].grinds)
      if (!this.coffeeOptions[this.coffeeParent]) {
        return false;
      }
      let grinds = this.coffeeOptions[this.coffeeParent].grinds;
      //console.log('grinds: ', typeof grinds, grinds)
      let theGrind = grinds.find(val => val === current);
      //console.log('theGrind: ', theGrind)
      return theGrind ? true : false;
    },
    checkSize(current) {
      //console.log('current', current)
      //console.log('this.coffeeOptions[this.coffeeParent]: ', this.coffeeOptions[this.coffeeParent].grinds)
      let sizes = this.coffeeOptions[this.coffeeParent].sizes;
      //console.log('grinds: ', typeof grinds, grinds)
      let theSize = sizes.find(val => val === current);
      //console.log('theGrind: ', theGrind)
      return theSize ? true : false;
    },

    setVariantGiftWrap(id) {
      this.giftWrapVariantId = id;
    },
    setVariantCartNote(id) {
      this.cartNoteVariantId = id;
    },

    getInput(name, email){
      this.giftName = name;
      this.giftEmail = email;
    },

    isActive(step) {
      if (step === this.currentStep || step === this.completedStep + 1) return 'active';
      if (step === 7 && this.completedStep === 5 && this.gift === false) return 'active';
      if (step === 7 && this.completedStep === 6 && this.gift === true) return 'active';
      return 'notActive'
    },

    addItemToCart(variant_id, qty, frequency, unit_type) {
      // Check if finalID looks like a product ID vs variant ID
      if (this.finalID) {
        // Fix: Find correct variant ID if we have a product ID
        if (this.finalID.toString().length > 11 && this.product && this.product.product) {
          var compareIt = this.size + ' / ' + this.beanGrind;

          for (let i = 0; i < this.product.variants.length; i++) {
            var variant = this.product.variants[i];
            if (variant.title === compareIt) {
              this.finalID = variant.id;
              this.variant = variant;
              break;
            }
          }
        }
      }

      if ( this.date === '' ) {
        let today =   new Date();
        this.date = today;
        this.dateFormat = moment(today).format('MMMM Do YYYY');
      }

      function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
      this.frequency = this.frequency.replace(/\D/g,'');

      // Set default values if missing BEFORE creating data object
      if (!this.quantity || this.quantity === '') {
        this.quantity = '1';
      }

      if (!this.duration || this.duration === '') {
        this.duration = 'Ongoing';
      }
      
      var data;
      
      if (this.gift) {
        // Gift products might have selling plans (new Shopify) or be ReCharge products (old)
        data = {
          "id": this.finalID,
          "quantity": 1,
          "properties": {
            "Choose_Coffee": this.coffeeType,
            "beanGrind": this.beanGrind,
            "Size": this.size,
            "Quantity": this.quantity,
            "Duration": this.duration,
            "Frequency": this.freq_gift_title,
            "gift_name": this.giftName,
            "gift_email": this.giftEmail,
            "gift_wrap": this.giftWrap,
            "scheduled_at": moment(this.date).format('YYYY-MM-DDTHH:mm:ss'),
            // Recharge-specific properties that are automatically honored
            "_rc_first_charge_date": moment(this.date).format('YYYY-MM-DD'),
            "delivery_date": moment(this.date).format('YYYY-MM-DD')
          }
        };
        
        // Check if the product has a selling plan (new Shopify subscriptions)
        if (this.hasSellingPlan && this.sellingPlanId) {
          data.selling_plan = this.sellingPlanId;
        } else if (this.product && this.product.selling_plan_groups && this.product.selling_plan_groups.length > 0) {
          // Fallback check if hasSellingPlan wasn't set
          var sellingPlanId = this.product.selling_plan_groups[0].selling_plans[0].id;
          data.selling_plan = sellingPlanId;
        }

        if (this.numShipments) {
          data.properties.expire_after_specific_number_of_charges = this.numShipments.toString();
        }
      } else {
        // Regular subscription
        data = {
          "id": this.finalID,
          "quantity": 1,
          "properties": {
            "Choose_Coffee": this.coffeeType,
            "beanGrind": this.beanGrind,
            "Size": this.size,
            "Quantity": this.quantity,
            "Duration": this.duration,
            "gift_name": this.giftName,
            "gift_email": this.giftEmail,
            "gift_wrap": this.giftWrap,
            "subscription_id": this.subscription_id,
            "scheduled_at": moment(this.date).format('YYYY-MM-DDTHH:mm:ss'),
            // Recharge-specific properties that are automatically honored
            "_rc_first_charge_date": moment(this.date).format('YYYY-MM-DD'),
            "delivery_date": moment(this.date).format('YYYY-MM-DD'),
            "shipping_interval_frequency": this.frequency,
            "shipping_interval_unit_type": "day",
            "order_interval_unit":"day",
            "order_interval_frequency":this.frequency
          }
        };
        
        // Add selling plan if available
        if (this.hasSellingPlan && this.sellingPlanId) {
          data.selling_plan = this.sellingPlanId;
        } else if (this.product && this.product.selling_plan_groups && this.product.selling_plan_groups.length > 0) {
          // Fallback: try to get selling plan if hasSellingPlan wasn't set
          const sellingPlans = this.product.selling_plan_groups[0].selling_plans;
          if (sellingPlans && sellingPlans.length > 0) {
            data.selling_plan = sellingPlans[0].id;
          }
        }
      }
      // this.whatEver is not available in the jQuery function below, so we set the values here:
      // because 'this' has a different context in that function
      // var isGift = this.giftWrap;
      var theCartNote = this.cartNote;
      var theCartNoteSelected = this.cartNoteSelected;
      var that = this.$store;


    //if we have a cart note variant ID, a cart note, the cart note checkbox selected and a gift wrap variant ID
      if ( this.cartNoteVariantId && this.cartNote && this.cartNoteSelected && this.giftWrap ) {
        data = { items: [
            data,
            {
              id: this.giftWrapVariantId,
              quantity: 1
            },
            {
              id: this.cartNoteVariantId,
              quantity: 1
            }
          ]
        }

        // else we may have a cart note variant ID, a cart note
      } else if ( this.cartNoteVariantId && this.cartNote && this.cartNoteSelected ) {
          data = { items: [
            data,
            {
              id: this.cartNoteVariantId,
              quantity: 1
            }
          ]
        }

        // and we may only have a gift wrap variant ID
      } else if ( this.giftWrap ) {
        data = { items: [
            data,
            {
              id: this.giftWrapVariantId,
              quantity: 1
            }
          ]
        }
      }

      

      function updateTheCart() {
        that.dispatch('cart/init');
      }

      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
          updateTheCart();
          if (theCartNote && theCartNoteSelected) {
            jQuery.post('/cart/update.js', {updates: {note: theCartNote}});
          }

          do {
            var token=get_cookie('cart');
          }
          while(token == undefined);

          var myshopify_domain='{{ shop.permanent_domain }}'
          try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
          var customer_param = '{% if customer %}customer_id={{customer.id}}&customer_email={{customer.email}}{% endif %}'
          var checkout_url = "/checkout?myshopify_domain=joshua-tree-coffee-company.myshopify.com&cart_token=" + token + "&" + ga_linker;
          setTimeout(function() {
            window.location = checkout_url
          }, 500)

        },
        error: function(xhr, status, error) {
          console.log('Cart add failed:', status, error);
        }
      });
    },
    setAppBg (imgPath, pad_top, pad_bottom) {
      let app_bg = document.querySelector('#subscription-app-wrap');
      if (app_bg) {
        //console.log('app_bg: ', app_bg)
        app_bg.style.backgroundImage = "url(" + imgPath + ")";
        app_bg.style.paddingTop = pad_top;
        app_bg.style.paddingBottom = pad_bottom;

      }
      return '';

    }

  }
}).$mount('#app');


} catch (error) {
  console.error('❌ Failed to initialize Vue:', error);
  console.error('Vue initialization stack trace:', error.stack);
  
  // Try to show a basic error message to the user
  var appElement = document.getElementById('app');
  if (appElement) {
    appElement.innerHTML = '<div style="padding: 20px; color: red; border: 1px solid red;">Vue application failed to load. Check browser console for details.</div>';
    appElement.style.display = 'block';
  }
}

let iconLinks = document.querySelectorAll('.service-icon-link');

const showHover = function(e) {
  let serviceIcon = e.target;
  let serviceIconSrc = serviceIcon.dataset.rollover_img;
  serviceIcon.querySelector('.service-icon-img').src = serviceIconSrc;
}
const showNormal = function(e) {
  let serviceIcon = e.target;
  let serviceIconSrc = serviceIcon.dataset.original_img;
  serviceIcon.querySelector('.service-icon-img').src = serviceIconSrc;
}

if ( iconLinks.length > 0 ) {
  iconLinks.forEach(function(el) {
    el.addEventListener('mouseenter', showHover);
    el.addEventListener('mouseleave', showNormal);
  })
}